import { render, staticRenderFns } from "./BuildYourOwnRM.vue?vue&type=template&id=0b471760&scoped=true"
import script from "./BuildYourOwnRM.vue?vue&type=script&lang=js"
export * from "./BuildYourOwnRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b471760",
  null
  
)

export default component.exports